import React, { useState } from "react";
import { Brand } from "./shared/Brand";
import { Footer } from "./sections/Footer";
import { Reveal } from "./shared/Reveal";
import WhatsAppButton from "./WhatsAppButton";
import GapFloat from "./GapFloat";

// The 9-step process. Draft copy — client can refine wording anytime.
const STEPS = [
  {
    title: "Complimentary Gap Analysis",
    body: "We start with a no-obligation review of your bills, tariffs and estate — pinpointing exactly where energy is being lost and where the biggest opportunities lie.",
  },
  {
    title: "Site Survey & Asset Audit",
    body: "Our engineers map every critical asset and sub-circuit on site, establishing a complete picture of how and where energy is actually consumed.",
  },
  {
    title: "Eniscope Installation",
    body: "High-accuracy metering hardware is fitted at the point of consumption, capturing energy and asset data minute by minute — making the invisible visible.",
  },
  {
    title: "Baseline & Benchmarking",
    body: "We establish a verified consumption baseline for every site, so future savings can be measured against real, evidenced data — not estimates.",
  },
  {
    title: "CII Intelligence Layer",
    body: "Raw data flows into our Central Intelligence Infrastructure, turning it into live dashboards, automated alerts and predictive insight across your whole estate.",
  },
  {
    title: "Opportunity Identification",
    body: "Our specialists interpret the data to surface waste, inefficiency and equipment faults — prioritising the actions that deliver the fastest, largest returns.",
  },
  {
    title: "Optimisation & Implementation",
    body: "We deploy targeted measures — from Solar PV and Battery Storage to control and behavioural changes — engineered to cut cost, carbon and risk.",
  },
  {
    title: "Continuous Verification",
    body: "Savings are tracked and verified in real time against your baseline, so you always have hard proof of performance and return on investment.",
  },
  {
    title: "VEM Boardroom Reporting",
    body: "Clear, board-ready reporting translates energy performance into financial and sustainability outcomes your leadership team can act on with confidence.",
  },
];

function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="evnav">
      <div className="wrap navin">
        <a href="/"><Brand /></a>
        <div className="navlinks">
          <a href="/">Home</a>
          <a href="/assets">What We Monitor</a>
          <a href="/#audio">Audio Library</a>
          <a href="/#solar-installs">Install Services</a>
          <a href="/gap-analysis-pages">Gap Analysis Pages</a>
          <a href="/marketing">Marketing</a>
          <a href="/#contact" className="btn" style={{ padding: "10px 20px" }}>Complimentary Gap Analysis</a>
        </div>
        <button className="navtoggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open}>
          {open ? (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          ) : (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
          )}
        </button>
      </div>
      {open && (
        <div className="navmobile">
          <a href="/">Home</a>
          <a href="/assets">What We Monitor</a>
          <a href="/#audio">Audio Library</a>
          <a href="/#solar-installs">Install Services</a>
          <a href="/gap-analysis-pages">Gap Analysis Pages</a>
          <a href="/marketing">Marketing</a>
          <a href="/#contact" className="btn">Complimentary Gap Analysis</a>
        </div>
      )}
    </nav>
  );
}

export default function HowItWorks() {
  return (
    <div className="evg">
      <Nav />

      <header className="prodhero">
        <div className="wrap">
          <Reveal className="eyebrow" tag="div" style={{ textAlign: "left" }}>THE DEEP DIVE · METHODOLOGY</Reveal>
          <Reveal tag="h1">How <span className="g">Eniscope &amp; CII</span> Work</Reveal>
          <Reveal className="intro" tag="p">
            For engineers and operations managers who want the technical detail — here&rsquo;s exactly how we
            measure, monitor and continuously optimise every critical asset across your estate.
          </Reveal>
          <a href="/assets" className="prodback">← Back to What We Monitor</a>
        </div>
      </header>

      <section style={{ paddingTop: 40 }}>
        <div className="wrap">
          <div className="twocol">
            <Reveal className="rv" tag="div">
              <div className="infocard">
                <div className="tagname">Eniscope</div>
                <div className="tagsub">Real-Time Metering Hardware</div>
                <p>High-accuracy, sub-circuit metering that captures energy and asset data minute by minute —
                making the invisible visible at the point of consumption.</p>
              </div>
            </Reveal>
            <Reveal className="rv" tag="div">
              <div className="infocard">
                <div className="tagname">CII</div>
                <div className="tagsub">Central Intelligence Infrastructure</div>
                <p>The platform layer that turns raw data into intelligence — dashboards, automated alerts,
                predictive insight and continuous verification of savings across every site.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="benefits-sec">
        <div className="wrap">
          <Reveal className="eyebrow" tag="div">HOW IT WORKS</Reveal>
          <Reveal className="h2" tag="div">The <span className="g">9-Step Process</span></Reveal>

          {STEPS.length > 0 && (
            <div className="steps">
              {STEPS.map((s, i) => (
                <Reveal className="rv" tag="div" key={i}>
                  <div className="stepcard" data-testid={`step-${i}`}>
                    <span className="sn">{i + 1}</span>
                    <div><h4>{s.title}</h4><p>{s.body}</p></div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}

          <Reveal tag="div" style={{ textAlign: "center", marginTop: 44 }}>
            <a href="/gap-analysis" className="btn">Book Your Complimentary Gap Analysis</a>
          </Reveal>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <GapFloat />
    </div>
  );
}
